
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class SplittingGrid extends Serenity.EntityGrid<SplittingRow, any> {
        protected getColumnsKey() { return 'Production.Splitting'; }
        protected getDialogType() { return SplittingDialog; }
        protected getIdProperty() { return SplittingRow.idProperty; }
        protected getInsertPermission() { return SplittingRow.insertPermission; }
        protected getLocalTextPrefix() { return SplittingRow.localTextPrefix; }
        protected getService() { return SplittingService.baseUrl; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container);
        }
        protected addButtonClick() {

            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(76);
            var userDefinition = Q.Authorization.userDefinition;
            this.editItem(<SplittingRow>{
                VoucherNo: voucherNo,
                TransDate: now.toDateString(),
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                VoucherTypeId: 76,
                EmployeeId: userDefinition.UserId,
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}